import { FC } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { MODAL_IDS, ModalItem, ModalSimple, Seo, useModal } from 'components'
import { useOnMount } from 'hooks'

import { contactDetailRoute, contactRoute } from '../../routes'
import { ContactDetailContent, ContactDetailTitle } from './components'

const ContactDetail: FC = () => {
  const navigate = useNavigate()

  const { openModal, closeModal } = useModal()
  const onClose = () => {
    navigate(contactRoute)
    closeModal(MODAL_IDS.ContactDetail)
  }
  const { id } = contactDetailRoute.useParams()

  useOnMount(() => openModal(MODAL_IDS.ContactDetail))

  return (
    <>
      <Seo
        description="Просмотр детальной информации контакта в сервисе QP5 Express: контактное лицо и номер телефона для связи."
        title="Информация о контакте – сборные перевозки QP5 Express"
      />
      <ModalItem id={MODAL_IDS.ContactDetail}>
        <ModalSimple id={MODAL_IDS.ContactDetail} onClose={onClose} title={<ContactDetailTitle id={id} />}>
          <ContactDetailContent id={id} />
        </ModalSimple>
      </ModalItem>
    </>
  )
}

export default ContactDetail
